import { createSelector } from 'reselect'
import entryDataSelector from '../entryDataSelector'
import { BuildabilityType } from '../../../entities/BuildabilityType'

const defaultBuildabilitySelector = createSelector(
    entryDataSelector,
    (entryData): BuildabilityType => entryData.defaultBuildability,
)
export default defaultBuildabilitySelector
